<template>
  <layout>
    <template v-slot:title>Display Rules</template>
    <template v-slot:header-buttons>
      <router-link to="/businessrules/create" class="btn btn-primary"
        >Create</router-link
      >
    </template>
    <div>
      <filter-control
        label="Filter rules"
        v-model="filter"
      ></filter-control>
      <div v-if="businessRules.length > 0">
        <table class="table cells-top">
          <thead>
            <table-header
              @sort-click="sortClicked"
              :current-sort-field="sortField"
            ></table-header>
          </thead>
          <tbody>
            <table-row
              v-for="(rule, index) in businessRules"
              :index="index"
              :key="rule.name"
              :business-rule="rule"
              @delete="deleteClicked"
            ></table-row>
          </tbody>
        </table>
        <pager
          :count="pages"
          :current-page="currentPage"
          @page-click="pageClicked"
        ></pager>
      </div>
      <div v-else class="mt-1"><p>No rules found.</p></div>
    </div>
    <template v-slot:modal>
      <confirm-delete-modal
        v-if="showDeleteModal"
        message="Are you sure you want to delete this rule?"
        @confirm="deleteConfirmed"
        @cancel="deleteCanceled"
      />
    </template>
  </layout>
</template>
<script>
import documentModelMixin from "@/mixins/documentModel";
import FilterControl from "@/components/common/filtering/FilterControl.vue";
import Pager from "@/components/common/pagination/Pager.vue";
import TableHeader from "@/components/business-rules/TableHeader.vue";
import TableRow from "@/components/business-rules/TableRow.vue";
import ConfirmDeleteModal from "@/components/common/confirmations/ConfirmDeleteModal.vue";
import { direction, sort } from "@/util/sort";
import { PAGE_SIZE } from "@/constants/pagination";

const sortClicked = function(args) {
  this.sortField = args.field;
  this.sortDirection = args.direction;
};

const pageClicked = async function(pageNo) {
  this.currentPage = pageNo;
};

const deleteClicked = function(id) {
  this.selectedRuleId = id;
  this.showDeleteModal = true;
};

const deleteCanceled = function() {
  this.selectedRuleId = null;
  this.showDeleteModal = false;
};

const deleteConfirmed = async function() {
  const model = this.documentModel;
  const rule = model.businessRules.find((r) => r.id === this.selectedRuleId);
  if (rule) {
    model.businessRules.splice(model.businessRules.indexOf(rule), 1);
    await this.saveDocumentModel(model);
    this.showDeleteModal = false;
  }
};

export default {
  components: {
    TableHeader,
    TableRow,
    FilterControl,
    Pager,
    ConfirmDeleteModal,
  },
  mixins: [documentModelMixin],
  data: function() {
    return {
      filter: "",
      sortField: "name",
      sortDirection: direction.ASCENDING,
      currentPage: 1,
      showDeleteModal: false,
    };
  },
  computed: {
    businessRules: function() {
      if (this.documentModel) {
        let rules = [...this.documentModel.businessRules];

        rules = rules.filter(
          (r) => r.name.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1
        );
        rules.sort(sort((r) => r[this.sortField], this.sortDirection));
        rules = rules.slice(
          (this.currentPage - 1) * PAGE_SIZE,
          this.currentPage * PAGE_SIZE
        );

        return rules;
      }

      return [];
    },
    pages: function() {
      if (this.documentModel) {
        return Math.ceil(this.documentModel.businessRules.length / PAGE_SIZE);
      }

      return 1;
    },
  },
  methods: {
    sortClicked,
    pageClicked,
    deleteClicked,
    deleteConfirmed,
    deleteCanceled,
  },
};
</script>
